//REACT-JS
import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//EXPORT
import TableToExcel from 'react-html-table-to-excel';

//COMPONENTS
import { relatorioAction } from '../../store/relatorio';

class TableEmailsValidadosOuInvalidos extends React.Component {

    constructor(props) {
        super(props);
    }

    static defaultProps = {
        name: "",
        selected: 0,
        onChange: function(e){}
    };

    componentDidMount() {
        
    }

    render() {

        const data = this.props.data; let html = "";
        const loading = this.props.loading;

        if (loading) {
            html = (<tr><td colSpan="4" scope="row">Carregando...</td></tr>);
        }
        else if (data.results === undefined || data.results.length === 0) {
            html = (<tr><td colSpan="4" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.results.length > 0) {
            html = data.results.map(row =>
                <tr key={row.identificador} id={row.identificador}>
                    <td>{row.empresa}</td>
                    <td>{row.email}</td>
                    <td>{row.motivoNaoRecebimento}</td>                
                    <td>{row.status}</td>
                </tr>                  
            );
        }

        return(
            <div style={{maxHeight: "400px", overflowY: "auto"}}>
                <div className="box-export ml-auto">Exportar dados como:
                    {this.export('excel')}
                </div>

                <table className="footable table table-striped toggle-arrow-tiny text-body" id="table-to-export">
                    <thead>
                        <tr style={{backgroundColor: "#dbf1e9"}}>
                            <th>Empresa</th>
                            <th>E-mail</th> 
                            <th>Motivo Não Recebimento</th>
                            <th>Status</th>
                        </tr>
                    </thead>

                    <tbody>{html}</tbody>
                </table>            
            </div>
        )
    }

    export(tipo){
        let fileName = '';
        if (this.props.tipoRelatorio === "5" ) {
            fileName = "emails_validados";
        } else {
            fileName = "emails_invalidos";
        }

        if(tipo == "excel"){
            return(<TableToExcel id="test-table-xls-button" className="btn-export" table="table-to-export" filename={fileName} buttonText="Excel"/>)
        }        
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, relatorio: state.relatorio };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { relatorio: bindActionCreators(relatorioAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TableEmailsValidadosOuInvalidos));